import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {Card, CardBody, CardHeader, Spinner} from 'reactstrap';
import {verify} from '../../../crud/checklist-limpeza.crud';
import moment from "moment";
import {formatBRL} from "../../../utils/Utils";

export default class LimpezaChecklistVerify extends Component {
    state = {
        loading: true,
        checklist: null,
        error: null,
    };

    componentDidMount() {
        const {
            match: {params},
        } = this.props;
        this.fetchChecklistData(params.code);
    }

    fetchChecklistData = (code) => {
        verify(code)
            .then((response) => {
                this.setState({checklist: response.data.data, loading: false});
            })
            .catch(() => {
                this.setState({error: 'Checklist não encontrado', loading: false});
            });
    };

    renderStatusCard = (status) => {
        const isExpired = status === 'vencido';
        const backgroundColor = isExpired ? 'red' : 'green';
        const color = 'white';

        const message = isExpired ? 'O documento passou da data de validade.' : 'Documento válido';

        return (
            <Card className="my-3" style={{backgroundColor, color}}>
                <CardBody>
                    <p className="mb-0 alert-bold">{message}</p>
                </CardBody>
            </Card>
        );
    };

    render() {
        const {loading, checklist, error} = this.state;

        if (loading) {
            return <Spinner/>;
        }

        if (error) {
            return (
                <div className="container">
                    <Card className="my-3">
                        <CardHeader>
                            <h1>Falha na validação do checklist!</h1>
                        </CardHeader>
                        <CardBody>
                            <p>O checklist associado a este QR Code não foi localizado. Confirme se o documento é válido ou tente escanear novamente.</p>
                        </CardBody>
                    </Card>
                </div>
            );
        }

        return (
            <div className="container">
                <Card className="my-3">
                    <CardHeader>
                        <h1>Validação de Autenticidade de Checklist de Limpeza #{checklist.id}</h1>
                    </CardHeader>
                </Card>
                {this.renderStatusCard(checklist.status)}
                <Card className="my-3">
                    <CardHeader>
                        <h3>Data de Emissão</h3>
                    </CardHeader>
                    <CardBody>
                        <p>Emitido em: {moment(`${checklist.created_at}`).format('DD/MM/YYYY [às] HH:mm ')}</p>
                        <p>Válido até: {moment(`${checklist.data_validade}`).format('DD/MM/YYYY [às] HH:mm ')}</p>
                    </CardBody>
                </Card>
                <Card className="my-3">
                    <CardHeader>
                        <h3>Emissor / Operador</h3>
                    </CardHeader>
                    <CardBody>
                        <p>Emissor: {checklist.lc_nome_emissor}</p>
                        <p>Operador: {checklist.lc_nome_operador}</p>
                        <p>Entrada no
                            Pátio: {moment(`${checklist.lc_dt_entrada_patio}`).format('DD/MM/YYYY [às] HH:mm ')}</p>
                    </CardBody>
                </Card>
                <Card className="my-3">
                    <CardHeader>
                        <h3>Identificação do Motorista e Veículo</h3>
                    </CardHeader>
                    <CardBody>
                        <p>Motorista: {checklist.lc_motorista_nome}</p>
                        <p>Telefone: {checklist.lc_motorista_telefone}</p>
                        <p>Placa Cavalo: {checklist.lc_placa_cavalo}</p>
                        <p>Placa Carreta 01: {checklist.lc_placa_carreta_01}</p>
                        <p>Placa Carreta 02: {checklist.lc_placa_carreta_02}</p>
                        <p>Placa Dolly: {checklist.lc_placa_carreta_03}</p>
                        <p>Tipo de Veículo: {checklist.lc_tipo_veiculo}</p>
                        <p>Capacidade Líquida: {checklist.lc_capacidade_liquida} ton</p>
                        <p>CPF: {checklist.lc_cpf}</p>
                    </CardBody>
                </Card>
                <Card className="my-3">
                    <CardHeader>
                        <h3>Informações da Carga</h3>
                    </CardHeader>
                    <CardBody>
                        <h5>Última Viagem</h5>
                        <p>Local de Descarga: {checklist.lc_ultimo_local_descarga}</p>
                        <p>Produto: {checklist.lc_ultima_descarga_produto}</p>
                        <p>Acondicionamento: {checklist.lc_ultima_descarga_acondicionamento}</p>
                        <hr/>
                        <h5>Viagem Atual</h5>
                        <p>Local Carregamento: {checklist.lc_local_carregamento}</p>
                        <p>Produto: {checklist.lc_produto_a_carregar}</p>
                        <p>Acondicionamento: {checklist.lc_acondicionamento_a_carregar}</p>
                        <p>Transportadora: {checklist.lc_transportadora_nome}</p>
                    </CardBody>
                </Card>
                <Card className="my-3">
                    <CardHeader>
                        <h3>Inspeção da Limpeza</h3>
                    </CardHeader>
                    <CardBody>
                        <p>Entrada: {moment(`${checklist.previsao_entrada_data} ${checklist.previsao_entrada_hora}`).format('DD/MM/YYYY [às] HH:mm ')}</p>
                        <p>Saída: {moment(`${checklist.previsao_saida_data} ${checklist.previsao_saida_hora}`).format('DD/MM/YYYY [às] HH:mm ')}</p>
                    </CardBody>
                </Card>
                <Card className="my-3">
                    <CardHeader>
                        <h3>Forma de Pagamento</h3>
                    </CardHeader>
                    <CardBody>
                        {checklist.pagamentos.map((pagamento, index) => (
                            <div key={index}>
                                <p>Tipo de Laudo: {pagamento.tipo_laudo}</p>
                                <p>Tipo de Pagamento: {pagamento.tipo_pagamento}</p>
                                <p>Pagador: {pagamento.pagador}</p>
                                <p>Valor: {formatBRL(pagamento.valor / 100)}</p>
                                {index < checklist.pagamentos.length - 1 && <hr />}
                            </div>
                        ))}
                    </CardBody>
                </Card>
                <Card className="my-3">
                    <CardHeader>
                        <h3>Fotos do Veículo</h3>
                    </CardHeader>
                    <CardBody style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-around', alignItems: 'flex-start' }}>
                        {checklist.lc_foto_veiculo_url && (
                            <div style={{ flex: '1 1 30%', maxWidth: '250px', margin: '5px', textAlign: 'center' }}>
                                <h5>Foto do Veículo</h5>
                                <img src={checklist.lc_foto_veiculo_url} alt="Foto do Veículo" style={{ maxWidth: '100%', height: 'auto' }}/>
                            </div>
                        )}
                        {checklist.lc_foto_carreta_01_url && (
                            <div style={{ flex: '1 1 30%', maxWidth: '250px', margin: '5px', textAlign: 'center' }}>
                                <h5>Foto da Carreta 01</h5>
                                <img src={checklist.lc_foto_carreta_01_url} alt="Foto da Carreta 01" style={{ maxWidth: '100%', height: 'auto' }}/>
                            </div>
                        )}
                        {checklist.lc_foto_carreta_02_url && (
                            <div style={{ flex: '1 1 30%', maxWidth: '250px', margin: '5px', textAlign: 'center' }}>
                                <h5>Foto da Carreta 02</h5>
                                <img src={checklist.lc_foto_carreta_02_url} alt="Foto da Carreta 02" style={{ maxWidth: '100%', height: 'auto' }}/>
                            </div>
                        )}
                    </CardBody>
                </Card>
            </div>
        );
    }
}
